export class SetIsBraintreePaymentMethodRequestableAction {
  static readonly type = '[Payment] Set Braintree Payment Method Requestable';

  constructor(public isPaymentMethodRequestable: boolean) {
  }
}
